import React, { useState, useContext } from "react"
import PropTypes from "prop-types"
import { nanoid } from "nanoid"

import { LangContext } from "../../context/langContext"

import { HeadingBasic } from "../heading/heading"
import { CardProject } from "../card-project/card-project"
import { CardProjectNew } from "../card-project/card-project-new"
import { CardSlider } from "../card-slider/card-slider"
import { CardNews } from "../card/card"
import { AntiLink } from "../utils/utils"

// { data } is an array of object consists of image, propertyName, type, location and linkTo.
// e.g [
//       {image: fluidImage, propertyName: 'Nuvasa Bay', type: 'residence', location: 'Kota Batam', linkTo:'/development/residence/nuvasa-bay,
//       {image: fluidImage, propertyName: 'Banjar Wijaya', type: 'residence', location: 'Tangerang', linkTo:'/development/residence/banjar-wijaya}
//      ]
export const Glider = ({ data, id, version }) => {
  const [unique] = useState(nanoid)

  return (
    <div className="px-0 px-lg-3">
      <CardSlider
        id={`${id}`}
        showInitial={3}
        arrowsMdDown={true}
        arrowsSmDown={true}
        noGutter
        showLgDown={2}
        showMdDown={1}
      >
        {version === "2"
          ? data.map((item, index) => {
              return (
                <CardProjectNew
                  key={`${item.propertyName}-${unique}-${index}`}
                  title={item.propertyName || item.title}
                  description={
                    `${
                      item.description ? item.description.substring(0, 145) : ""
                    }${
                      item.description
                        ? item.description.length > 145
                          ? "..."
                          : ""
                        : ""
                    }` ||
                    `${item.excerpt ? item.excerpt.substring(0, 145) : ""}${
                      item.excerpt
                        ? item.excerpt.length > 145
                          ? "..."
                          : ""
                        : ""
                    }` ||
                    "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
                  }
                  img={
                    item.image ||
                    (item.featuredImage && item.featuredImage.sourceUrl) ||
                    "https://ap-bismite-yk88.antikode.dev/app/uploads/2020/03/img_development-main-2.jpg"
                  }
                  category={
                    item.type ||
                    (item.propertyTypes &&
                      item.propertyTypes.nodes[0] &&
                      item.propertyTypes.nodes[0].name) ||
                    null
                  }
                  location={item.location || null}
                  link={
                    item.linkTo ||
                    `/development/${item?.propertyTypes?.nodes[0] &&
                      item?.propertyTypes?.nodes[0]?.slug}/${item?.slug}` ||
                    "/"
                  }
                  target={item.target && item.target}
                  className="col ratio-1-1 project-card-red"
                  locationFrom={item.pathnameProject}
                  facilities={item.facilities || null}
                />
              )
            })
          : data.map((item, index) => {
              return (
                <CardProject
                  key={`${item.propertyName}-${unique}-${index}`}
                  title={item.propertyName || item.title}
                  description={
                    `${
                      item.description ? item.description.substring(0, 145) : ""
                    }${
                      item.description
                        ? item.description.length > 145
                          ? "..."
                          : ""
                        : ""
                    }` ||
                    `${item.excerpt ? item.excerpt.substring(0, 145) : ""}${
                      item.excerpt
                        ? item.excerpt.length > 145
                          ? "..."
                          : ""
                        : ""
                    }` ||
                    "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
                  }
                  img={
                    item.image ||
                    (item.featuredImage && item.featuredImage.sourceUrl) ||
                    "https://ap-bismite-yk88.antikode.dev/app/uploads/2020/03/img_development-main-2.jpg"
                  }
                  category={
                    item.type ||
                    (item.propertyTypes &&
                      item.propertyTypes.nodes[0] &&
                      item.propertyTypes.nodes[0].name) ||
                    null
                  }
                  location={item.location || null}
                  link={
                    item.linkTo ||
                    `/development/${item?.propertyTypes?.nodes[0] &&
                      item?.propertyTypes?.nodes[0]?.slug}/${item?.slug}` ||
                    "/"
                  }
                  target={item.target && item.target}
                  className="px-sm-down-0 col ratio-1-1"
                  locationFrom={item.pathnameProject}
                />
              )
            })}
      </CardSlider>
    </div>
  )
}

Glider.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  linkTo: PropTypes.string,
  id: PropTypes.string,
  glideIndex: PropTypes.number,
}

export const OverseasProjectsSlider = ({ data, projects }) => {
  const { lang } = useContext(LangContext)

  if (data.innerBlocks[1].name === "core/shortcode") {
    const shortcodeText = data.innerBlocks[1].attributes.text
    const shortcodeTextSplit = shortcodeText.split("projects-")

    const currentProjects = projects.reduce((result, currentValue) => {
      if (lang === "EN") {
        if (
          currentValue &&
          currentValue.projectTags &&
          currentValue.projectTags.nodes.length > 0 &&
          currentValue.projectTags.nodes.find(
            x =>
              x.name.toLowerCase() ===
              shortcodeTextSplit[1].split("-").join(" ")
          )
        ) {
          result.push(currentValue)
        }
      } else if (lang === "ID" && currentValue?.translation) {
        if (
          currentValue &&
          currentValue.translation &&
          currentValue.translation.projectTags &&
          currentValue.translation.projectTags.nodes.length > 0 &&
          currentValue.translation.projectTags.nodes.find(
            x =>
              x.name.toLowerCase() ===
              shortcodeTextSplit[1].split("-").join(" ")
          )
        ) {
          result.push(currentValue)
        }
      } else if (lang === "ID" && !currentValue?.translation) {
        if (
          currentValue &&
          currentValue.projectTags &&
          currentValue.projectTags.nodes.length > 0 &&
          currentValue.projectTags.nodes.find(
            x =>
              x.name.toLowerCase() ===
              shortcodeTextSplit[1].split("-").join(" ")
          )
        ) {
          result.push(currentValue)
        }
      }
      return result
    }, [])

    return (
      <section className="py-3 overflow-x-hidden">
        <div className="container">
          <HeadingBasic h3={data.innerBlocks[0].attributes.content} />
          <Glider data={currentProjects} />
        </div>
      </section>
    )
  }
  return <div></div>
}

export const GliderVirtualLink = ({ data, id }) => {
  const [unique] = useState(nanoid)

  return (
    <div className="px-0 px-lg-3">
      <CardSlider
        id={`${id}`}
        showInitial={3}
        arrowsMdDown={true}
        arrowsSmDown={true}
        noGutter
      >
        {data.map((item, index) => {
          return (
            <CardProject
              key={`${item.propertyName}-${unique}-${index}`}
              title={item.propertyName || item.title}
              description={
                `${
                  item.description ? item.description.substring(0, 170) : ""
                }` ||
                `${item.excerpt ? item.excerpt.substring(0, 170) : ""}` ||
                "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
              }
              img={
                item.image ||
                (item.featuredImage && item.featuredImage.sourceUrl) ||
                "https://ap-bismite-yk88.antikode.dev/app/uploads/2020/03/img_development-main-2.jpg"
              }
              category={
                item.type ||
                (item.propertyTypes &&
                  item.propertyTypes.nodes[0] &&
                  item.propertyTypes.nodes[0].name) ||
                null
              }
              location={item.location || null}
              link={
                item.linkTo ||
                `/development/${item.propertyTypes.nodes[0] &&
                  item.propertyTypes.nodes[0].slug}/${item.slug}` ||
                "/"
              }
              target={item.target && item.target}
              className="px-sm-down-0 col ratio-1-1"
            />
          )
        })}
      </CardSlider>
    </div>
  )
}

export const GliderVirtualLinkNew = ({ data, id }) => {
  const [unique] = useState(nanoid)

  return (
    <div className="px-lg-3">
      <CardSlider
        id={`${id}`}
        showInitial={1}
        arrowsMdDown={true}
        arrowsSmDown={true}
      >
        {data.map((item, index) => {
          const link =
            item.linkTo ||
            `/development/${item.propertyTypes.nodes[0] &&
              item.propertyTypes.nodes[0].slug}/${item.slug}` ||
            "/"
          const target = item.target && item.target
          const title = item.propertyName || item.title
          const img =
            item.image ||
            (item.featuredImage && item.featuredImage.sourceUrl) ||
            "https://ap-bismite-yk88.antikode.dev/app/uploads/2020/03/img_development-main-2.jpg"

          return (
            <div
              className={`virtual-link-wrapper`}
              key={`${item.propertyName}-${unique}-${index}`}
            >
              <AntiLink to={link} target={target}>
                <div
                  alt={title}
                  className="virtual-link-image"
                  style={{
                    background: `url(${img}) no-repeat center`,
                    backgroundSize: "cover",
                  }}
                >
                  <div className="virtual-link-desc">
                    <span
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    ></span>
                  </div>
                </div>
              </AntiLink>
            </div>
          )
        })}
      </CardSlider>
    </div>
  )
}

export const WvcNewsSlider = ({ data, id }) => {
  const [unique] = useState(nanoid)
  const list = data.map((item, index) => {
    return (
      <CardNews
        key={`${item.title}-${unique}-${index}`}
        title={item.title}
        description={`${
          item.description
            ? item.description.substring(0, 60)
            : "Lorem ipsum dolor, sit amet consectetur adipisicing elit. Provident deserunt laborum nostrum."
        }
                ${
                  item.description
                    ? item.description.length > 60
                      ? "..."
                      : ""
                    : ""
                }`}
        image={item.image ? item.image : "#"}
        link={item.link || "/"}
        category={item.category || null}
        className="px-sm-down-0 col ratio-1-1 mb-2"
        target={item.target || "_self"}
      />
    )
  })
  return (
    <>
      <div className="px-0 d-none d-md-block">
        <CardSlider
          id={`${id}`}
          showInitial={3}
          arrowsMdDown={true}
          arrowsSmDown={true}
          noGutter
        >
          {list}
        </CardSlider>
      </div>
      <div className="px-0 px-lg-3 d-md-none">{list}</div>
    </>
  )
}

WvcNewsSlider.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  link: PropTypes.string,
  id: PropTypes.string,
}
